import React from 'react';

const h = React.createElement;
export const expressionText = (slot) => typeof slot?.value === 'number' && Number.isFinite(slot.value)
  ? String(slot.value) : `Missing: ${slot?.missing_reason || 'not_recorded'}`;
const supplied = (value) => value != null && value !== '' && (!Array.isArray(value) || value.length > 0);
const text = (value) => typeof value === 'object' ? JSON.stringify(value) : String(value);
const fields = (items) => h('dl', { className: 'neuroviz-cell-fields' }, items.filter(([, value]) => supplied(value)).map(([label, value]) => h('div', { key: label }, h('dt', null, label), h('dd', null, text(value)))));
const ExpressionTable = ({ collection, expression }) => h(React.Fragment, null,
  h('h3', null, collection ? `Measured expressions · ${expression?.total_genes ?? 'pending'} genes` : 'Eight measured expressions'),
  expression?.normalization && h('p', null, expression.normalization),
  h('div', { className: 'neuroviz-table-wrap', tabIndex: 0, role: 'region', 'aria-label': 'Scrollable gene measurements' },
    h('table', null,
      h('caption', null, 'Measured values and explicit missing reasons'),
      h('thead', null, h('tr', null, ['Gene', 'Exact identifier', 'Value / missing reason'].map((label) => h('th', { key: label, scope: 'col' }, label)))),
      h('tbody', null, (expression?.items || []).map((slot) => h('tr', { key: slot.gene_id },
        h('td', null, slot.gene_symbol || slot.symbol || slot.gene_id),
        h('td', null, slot.gene_id),
        h('td', null, expressionText(slot)),
      ))),
    ),
  ),
);

/** Only render evidence for the current stable ID, including the render before effects run. */
export function CellDetail({ entityId, status, data, error, expanded = false, onPrevious, onNext, hasPrevious, hasNext, collection = false, expressionControls = null }) {
  const ready = status === 'ready' && data?.entity?.entity_id === entityId;
  const entity = ready ? data.entity : null;
  const annotation = collection && entity ? {
    specimen_id: entity.specimen_id, source_section: entity.source_section,
    layer: entity.anatomy?.layer, class: {id:entity.taxonomy?.class_id,label:entity.taxonomy?.class_label},
    subclass: {id:entity.taxonomy?.subclass_id,label:entity.taxonomy?.subclass_label},
    annotation_confidence: entity.annotation_confidence,
  } : entity?.annotation || {};
  return h('section', { className: 'neuroviz-panel neuroviz-cell-detail', 'aria-label': 'Selected cell evidence' },
    h('h2', null, 'Selected cell'),
    h('div', { role: 'group', 'aria-label': 'Navigate selected entities' },
      h('button', { type: 'button', disabled: !hasPrevious, onClick: onPrevious }, '← Previous'),
      h('span', { className: 'neuroviz-cell-id',title:entityId }, entityId ? (entityId.length>25?entityId.slice(0,15)+'…'+entityId.slice(-6):entityId) : 'No cell selected'),
      h('button', { type: 'button', disabled: !hasNext, onClick: onNext }, 'Next →')),
    (!entityId || !ready) && h('p', { role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' }, !entityId ? 'Select a cell to inspect it.' : status === 'error' || status === 'unavailable' || status === 'unauthorized' ? (error?.status === 403 ? 'Cell evidence is restricted.' : 'Cell evidence is unavailable.') : 'Loading selected cell…'),
    ready && fields([['Specimen', annotation.specimen_id], ['Source section', annotation.source_section], ['Region', entity.anatomy?.region_name || entity.anatomy?.region_id || entity.region?.name || entity.region_id], ['Layer', annotation.layer], ['Provider class', annotation.class?.label || annotation.class?.id], ['Provider subclass', annotation.subclass?.label || annotation.subclass?.id], ['Annotation confidence (not quality score)', annotation.annotation_confidence], ['Quality score', entity.quality_score]]),
    ready && expanded && h(React.Fragment, null,
      collection && fields([['Position', entity.position]]),
      expressionControls,
      h(ExpressionTable, { collection, expression: data.expression }),
    ),
  );
}
